export default "__VITE_ASSET__BGS78sQX__"